import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CallStatus, FilterBoolean } from '../company-call-history-filters.model';

@Component({
  selector: 'filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDropdownComponent),
      multi: true
    }
  ]
})
export class FilterDropdownComponent implements ControlValueAccessor {

  @Input() public options: any[];
  @Input() public type: string;

  public value: string;
  public onChange: any = () => { };
  public onTouch: any = () => { };

  public selectedOption: any;

  constructor() {}

  ngOnInit() {
  }

  public selectOption(obj: any) {
    this.selectedOption = obj;
    this.onChange(this.selectedOption);
  }

  writeValue(obj: any): void {
    if (obj !== undefined || obj !== null) {
      switch(this.type) {
        case 'boolean':
          this.selectedOption = obj ? FilterBoolean.yes : FilterBoolean.no;
          break;
        case 'call_status':
          this.selectedOption = obj ? CallStatus.answered : CallStatus.unanswered;
          break;
        default:
          this.selectedOption = obj;
      }
      this.onChange(this.selectedOption);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    if(this.selectOption) this.onChange(this.selectedOption);
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}
